import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';



export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];



@Component({
  selector: 'app-logdetail',
  templateUrl: './logdetail.component.html',
  styleUrls: ['./logdetail.component.scss']
})
export class LogdetailComponent implements OnInit {


  displayedColumns: string[] = ['Time', 'LogLevel', 'UserId', 'FacilityID', 'Action', 'Message'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);


  @Output() onCountsReceive: EventEmitter<any> = new EventEmitter();



  @ViewChild(MatSort, { static: true }) sort: MatSort;
  
  timevalue;

  LogData;
  OrginalLogData;

  macId = "NA";
  deviceId = "NA";
  appVersion = "NA";
  appId = "NA";
  EMROperator = "NA";


  info;
  warning;
  debug;
  error;
  apihit;

  public fileContent: string;

  constructor() { 

    this.fileContent = "";
    this.LogData = [];
    this.OrginalLogData = [];

    this.info = 0;
    this.warning = 0;
    this.debug = 0;
    this.error = 0;
    this.apihit = 0;


  }
  @Input('file') file : File;

  ngOnInit() {

    this.readFile(this.file);
  }

  readFile(file: File) {
    var reader = new FileReader();
    reader.onload = () => {
        console.log(reader.result);
        this.renderFileContent(reader.result.toString());

    };
    reader.readAsText(file);
}

//==========================================================================================


  // When the user drops a text-file on the file-drop component, it will emit the
  // file-content as an event. I render the emitted file-content to the view.
  public renderFileContent(value: string): void {

    //this.fileContent = value;



    console.log('fileValues');

    var arrayList = value.split('\n');

    var position = 1;

    arrayList.forEach(log => {


      // 2019-11-22T03:17:49-42:42 LogLevel="DEBUG"
      // macId="b4:ce:f6:9d:fb:c2" deviceId="c21b18248ad66be7"
      //appVersion="8.00.05" appId="RC2.0" userId="NA"
      // EMROperator="NA" FacID="NA" action="GET" message="Login Page Token Receiving"

      var datetime = log.substring(0, 25);

      var loglevel = this.getLogValue(log, "LogLevel", "macId");

      if (this.equalIgnorecase(loglevel, "DEBUG")) {
        this.debug++;
      } else if (this.equalIgnorecase(loglevel, "INFO")) {
        this.info++;
      } else if (this.equalIgnorecase(loglevel, "ERROR")) {
        this.error++;
      } else if (this.equalIgnorecase(loglevel, "WARNING")) {
        this.warning++;
      }


      var macId = this.getLogValue(log, "macId", "deviceId");
      var deviceId = this.getLogValue(log, "deviceId", "appVersion");
      var appVersion = this.getLogValue(log, "appVersion", "appId");
      var appId = this.getLogValue(log, "appId", "userId");
      var EMROperator = this.getLogValue(log, "EMROperator", "FacID");

      if (macId !== undefined || macId !== null) {
        this.macId = macId;
      }
      if (deviceId !== undefined || deviceId !== null) {
        this.deviceId = deviceId;
      }
      if (appVersion !== undefined || appVersion !== null) {
        this.appVersion = appVersion;
      }

      if (appId !== undefined || appId !== null) {
        this.appId = appId;
      }

      if (deviceId !== undefined || deviceId !== null) {
        this.EMROperator = EMROperator;
      }

      var userId = this.getLogValue(log, "userId", "EMROperator").toString();
      var FacID = this.getLogValue(log, "FacID", "action");
      var action = this.getLogValue(log, "action", "message");


      if (this.equalIgnorecase(action, "API URL")) {
        this.apihit++;
      }

      var message = log.substring(log.indexOf("message=\"") + 9, log.length - 1)


     // console.log(userId);

      var timevalue: string = datetime.split('T')[1];


      //console.log(timevalue);

      if(timevalue!=undefined){
      this.LogData.push(
        {
          'no': position,
          'datetime': datetime,
          'time':timevalue.substring(0,8),
          'loglevel': loglevel,
          'userId': userId,
          'FacID': FacID,
          'action': action,
          'message': message,

        }
      );

      position++;
      }
    });


    this.OrginalLogData = this.LogData;
    console.log(this.LogData.length);

    var countsData  = {
      warning : String(this.warning),
      error: String(this.error),
      total: String(this.OrginalLogData.length),
      name: this.file.name

    };

    this.onCountsReceive.emit(countsData);

  }
  public equalIgnorecase(a, b) {
    return typeof a === 'string' && typeof b === 'string'
      ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
      : a === b;
  }

  showOnlyINFO() {
    this.showAllLogs = true;
    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "INFO") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }

  showOnlyWARNING() {
    this.showAllLogs = true;
    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "WARNING") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }

  showOnlyERROR() {
    this.showAllLogs = true;
    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "ERROR") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }
  showOnlyDEBUG() {
    this.showAllLogs = true;
    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "DEBUG") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }

  showOnlyShowALL() {
    this.showAllLogs = true;
    this.LogData = this.OrginalLogData;

  }

  public getLogValue(logdata: string, startColumn: string, endColumn: string): string {
    var startIndex = logdata.indexOf(startColumn + "=\"") + startColumn.length;
    var endIndex = logdata.indexOf(endColumn + "=\"") - 1;

    if (startIndex === -1 || endIndex === -1) {
      return "NA";
    }
    var loglevel = logdata.substring(startIndex + 2, endIndex - 1).trim();

    return loglevel;
  }

  showAllLogs : boolean = false;
  showAllLogFiles()
  {
    this.showAllLogs = !this.showAllLogs;

  }

//==============================================================================================

}
